module.exports = __webpack_public_path__ + "img/platform_04_personaliseer.fa834d74.png";